import React from "react"
import { RenderElementProps } from "slate-react"

const CheckListUl = ({ children, attributes }: RenderElementProps) => {
    return (
        <ul {...attributes} className="mb-4 list-none text-md last:mb-0 sm:mb-5 sm:text-lg lg:text-xl">
            {children}
        </ul>
    )
}

export default CheckListUl
